import { getDocumentStore } from "../components/DocumentEditor/useDocumentStore";
import { getCreateFileStore } from "../components/CreateFile/useCreateFileStore";
import { getEmailStore } from "../components/Email/useEmailStore";
import { getCodeStore } from "../components/Code/useCodeStore";
import { getAPIResReqStore } from "../components/APIRequestAndResponse/useAPIResReqStore";
import { getSlackStore } from "../components/Slack/useSlackStore";
import { getQueryDatabaseStore } from "../components/QueryDatabase/useQueryDatabaseStore";
import { getUpdateDatabaseRecordStore } from "../components/UpdateDatabaseRecord/useUpdateDatabaseRecordStore";
import { getCreateDatabaseRecordStore } from "../components/CreateDatabaseRecord/useCreateDatabaseRecordStore";
import { getConditionalLogicStore } from "../components/ConditionalLogic/useConditionalLogicStore";
import { getConditionalWorkflowStore } from "../components/ConditionalWorkflow/useConditionalWorkflowStore";
import { getConditionalWorkflowPathStore } from "../components/ConditionalWorkflowPath/useConditionalWorkflowPathStore";
import { getLoopThroughListStore } from "../components/LoopThroughList/useLoopThroughListStore";
import { getTimeDelayStore } from "../components/TimeDelay/useTimeDelayStore";
import { getTriggerAZapStore } from "../components/TriggerAZap/useTriggerAZapStore";
import { getTriggerFromZapierStore } from "../components/TriggerFromZapier/useTriggerFromZapierStore";
import { getTriggerFromExternalStore } from "../components/TriggerFromExternal/useTriggerFromExternalStore";
import { getPerformActionExternalStore } from "../components/PerformActionExternal/usePerformActionExternalStore";
import { getTriggerAnotherWorkflowStore } from "../components/TriggerAnotherWorkflow/useTriggerAnotherWorkflowStore";
import { getTriggerFromAWorkflowStore } from "../components/TriggerFromAWorkflow/useTriggerFromAWorkflowStore";
import { getTriggerOnDatabaseUpdateStore } from "../components/TriggerOnDatabaseUpdate/useTriggerOnDatabaseUpdateStore";
import { getTriggerFromApiPollingStore } from "../components/TriggerFromApiPolling/useTriggerFromApiPollingStore";
import { getEmailTriggerStore } from "../components/EmailTrigger/useEmailTriggerStore";
import { getWebhookImportStore } from "../components/WebhookImport/useWebhookImportStore";
import { getWebhookTriggerStore } from "../components/WebhookTrigger/useWebhookTriggerStore";
import { getSessionVariableStore } from "../components/SessionVariable/useSessionVariableStore";
import { getCalculatorStore } from "../components/Calculator/useCalculatorStore";
import { getMergeWorkflowStore } from "../components/MergeWorkflow/useMergeWorkflowStore";
import { getConvergeThreadsStore } from "../components/ConvergeThreads/useConvergeThreadsStore";
import { getBulkAssessmentStore } from "../components/BulkAssessment/useBulkAssessmentStore";
import { getParseJSONStore } from "../components/ParseJSON/useParseJSONStore";
import { getBranchPathsStore } from "../components/BranchPaths/useBranchPathsStore";
import { getTransformStore } from "../components/ListTransform/useTransformStore";
import { getAIAssistantTemplateStore } from "../components/AIAssistant/useAIAssistantTemplateStore";
import { getAIAgentStore } from "../components/AIAgent/useAIAgentStore";
import { getAwaitExternalEventStore } from "../components/AwaitExternalEvent/useAwaitExternalEventStore";
import { getApiExportStore } from "../components/ApiExport/useApiExportStore";
import { getHttpRequestStore } from "../components/HttpRequest/useHttpRequestStore";
import { getScheduleStartStore } from "../components/ScheduleStart/useScheduleStartStore";
import { getFormBuilderStore } from "../components/FormBuilder/useFormBuilderStore";
import { getSequentialFormStore } from "../components/SequentialForm/useSequentialFormStore";
import { getDynamicFormStore } from "../components/DynamicFormBuilder/useDynamicFormStore";
import { getDynamicReviewTaskStore } from "../components/DynamicReviewTask/useDynamicReviewTaskStore";
import { getFormStepStore } from "../components/FormStep/useFormStepStore";
import { getArtifactStore } from "../components/Artifacts/useArtifactStore";
import { getGatewayStore } from "../components/Gateway/useGatewayStore";
import { getQueryTableV2Store } from "../components/QueryTableV2/useQueryTableV2Store";
import { getCreateRowV2Store } from "../components/CreateRowV2/useCreateRowV2Store";
import { getUpdateRowV2Store } from "../components/UpdateRowV2/useUpdateRowV2Store";
import { getTriggerTableV2Store } from "../components/TriggerTableV2/useTriggerTableV2Store";
import { getTriggerOnArtifactStore } from "../components/TriggerOnArtifact/useTriggerOnArtifactStore";
import { getCreateBoardTicketStore } from "../components/CreateBoardTicket/useCreateBoardTicketStore";
import { getGetBoardTicketStore } from "../components/GetBoardTicket/useGetBoardTicketStore";
import { getUpdateBoardTicketStore } from "../components/UpdateBoardTicket/useUpdateBoardTicketStore";
import { getTriggerOnBoardTicketStore } from "../components/TriggerOnBoardTicket/useTriggerOnBoardTicketStore";
import { getCustomFunctionInstanceStore } from "../components/CustomFunctions/useCustomFunctionInstanceStore";
import useProjectStore from "../components/ProjectCanvas/useProjectStore";

import { protectLoadedStore } from "./storeWriteGuard";

// Maps component type to { getStore, setter }
// All stores now use the standard setComponentData interface.
export const storeMap = {
  document_editor: { getStore: getDocumentStore, setter: "setComponentData" },
  create_file: { getStore: getCreateFileStore, setter: "setComponentData" },
  email: { getStore: getEmailStore, setter: "setComponentData" },
  code: { getStore: getCodeStore, setter: "setComponentData" },
  advanced_code: { getStore: getCodeStore, setter: "setComponentData" },
  form: { getStore: getFormBuilderStore, setter: null },
  sequential_form: { getStore: getSequentialFormStore, setter: null },
  form_section: { getStore: getSequentialFormStore, setter: null },
  api_request_and_response: {
    getStore: getAPIResReqStore,
    setter: "setComponentData",
  },
  http_request: { getStore: getHttpRequestStore, setter: "setComponentData" },
  slack: { getStore: getSlackStore, setter: "setComponentData" },
  query_database_record: {
    getStore: getQueryDatabaseStore,
    setter: "setComponentData",
  },
  data_bank: { getStore: getQueryDatabaseStore, setter: "setComponentData" },
  update_database_record: {
    getStore: getUpdateDatabaseRecordStore,
    setter: "setComponentData",
  },
  create_database_record: {
    getStore: getCreateDatabaseRecordStore,
    setter: "setComponentData",
  },
  conditional_logic: {
    getStore: getConditionalLogicStore,
    setter: "setComponentData",
  },
  conditional_workflow: {
    getStore: getConditionalWorkflowStore,
    setter: "setComponentData",
  },
  conditional_workflow_path: {
    getStore: getConditionalWorkflowPathStore,
    setter: "setComponentData",
  },
  loop_through_list: {
    getStore: getLoopThroughListStore,
    setter: "setComponentData",
  },
  time_delay: { getStore: getTimeDelayStore, setter: "setComponentData" },
  trigger_a_zap: { getStore: getTriggerAZapStore, setter: "setComponentData" },
  trigger_from_zapier: {
    getStore: getTriggerFromZapierStore,
    setter: "setComponentData",
  },
  trigger_from_external_app: {
    getStore: getTriggerFromExternalStore,
    setter: "setComponentData",
  },
  perform_action_in_external_app: {
    getStore: getPerformActionExternalStore,
    setter: "setComponentData",
  },
  trigger_another_workflow: {
    getStore: getTriggerAnotherWorkflowStore,
    setter: "setComponentData",
  },
  trigger_from_a_workflow: {
    getStore: getTriggerFromAWorkflowStore,
    setter: "setComponentData",
  },
  trigger_on_database_update: {
    getStore: getTriggerOnDatabaseUpdateStore,
    setter: "setComponentData",
  },
  trigger_from_api_polling: {
    getStore: getTriggerFromApiPollingStore,
    setter: "setComponentData",
  },
  trigger_via_email: {
    getStore: getEmailTriggerStore,
    setter: "setComponentData",
  },
  webhook: { getStore: getWebhookImportStore, setter: "setComponentData" },
  webhook_trigger: {
    getStore: getWebhookTriggerStore,
    setter: "setComponentData",
  },
  webhook_trigger_v2: {
    getStore: getWebhookTriggerStore,
    setter: "setComponentData",
  },
  session_variables: {
    getStore: getSessionVariableStore,
    setter: "setComponentData",
  },
  calculator: { getStore: getCalculatorStore, setter: "setComponentData" },
  merge_workflow: {
    getStore: getMergeWorkflowStore,
    setter: "setComponentData",
  },
  converge_threads: {
    getStore: getConvergeThreadsStore,
    setter: "setComponentData",
  },
  bulk_assessment: {
    getStore: getBulkAssessmentStore,
    setter: "setComponentData",
  },
  parse_json: { getStore: getParseJSONStore, setter: "setComponentData" },
  branch_paths: { getStore: getBranchPathsStore, setter: "setComponentData" },
  list_transform: { getStore: getTransformStore, setter: "setComponentData" },
  ai_assistant: {
    getStore: getAIAssistantTemplateStore,
    setter: "setComponentData",
  },
  ai_agent: { getStore: getAIAgentStore, setter: "setComponentData" },
  await_external_event: {
    getStore: getAwaitExternalEventStore,
    setter: "setComponentData",
  },
  api_export: { getStore: getApiExportStore, setter: "setComponentData" },
  schedule_start: {
    getStore: getScheduleStartStore,
    setter: "setComponentData",
  },
  dynamic_form: { getStore: getDynamicFormStore, setter: "setComponentData" },
  dynamic_review_task: {
    getStore: getDynamicReviewTaskStore,
    setter: "setComponentData",
  },
  form_step: { getStore: getFormStepStore, setter: "setComponentData" },
  artifact: { getStore: getArtifactStore, setter: "setComponentData" },
  gateway: { getStore: getGatewayStore, setter: "setComponentData" },
  query_table_v2: {
    getStore: getQueryTableV2Store,
    setter: "setComponentData",
  },
  create_row_v2: { getStore: getCreateRowV2Store, setter: "setComponentData" },
  update_row_v2: { getStore: getUpdateRowV2Store, setter: "setComponentData" },
  trigger_table_v2: {
    getStore: getTriggerTableV2Store,
    setter: "setComponentData",
  },
  trigger_on_artifact: {
    getStore: getTriggerOnArtifactStore,
    setter: "setComponentData",
  },
  create_board_ticket: {
    getStore: getCreateBoardTicketStore,
    setter: "setComponentData",
  },
  get_board_ticket: {
    getStore: getGetBoardTicketStore,
    setter: "setComponentData",
  },
  update_board_ticket: {
    getStore: getUpdateBoardTicketStore,
    setter: "setComponentData",
  },
  trigger_on_board_ticket: {
    getStore: getTriggerOnBoardTicketStore,
    setter: "setComponentData",
  },
  custom_function: {
    getStore: getCustomFunctionInstanceStore,
    setter: "setComponentData",
  },
};

function buildComponentStorePayload(
  comp,
  componentData,
  version,
  componentType,
) {
  return {
    componentId: comp.componentId,
    type: componentType,
    description: comp.description,
    componentData,
    version,
  };
}

export function hydrateComponentStoreFromComponent(
  comp,
  version,
  fallbackType,
  options = {},
) {
  if (!comp) return false;

  const componentType = comp.type || fallbackType;
  if (!componentType) return false;

  const config = storeMap[componentType];
  if (!config?.setter) return false;

  const componentData = comp.rawComponentData || comp.componentData;
  if (!componentData) return false;

  try {
    const store = config.getStore(comp.componentId);
    const state = store.getState();

    if (
      state.loaded &&
      state.componentId === comp.componentId &&
      state._loadProtected
    ) {
      return true;
    }
    if (typeof state[config.setter] !== "function") return false;

    state[config.setter](
      buildComponentStorePayload(comp, componentData, version, componentType),
    );

    store.setState({
      loaded: true,
      projectId:
        comp.projectId ||
        options.projectId ||
        useProjectStore.getState().project_id,
      workflowVersion: version,
      loadedFrom:
        options.loadedFrom ||
        (comp.rawComponentData ? "FullCanvasProject" : "ComponentDetailDto"),
      name: comp.componentData?.name || componentData?.name || "",
      componentDescription: comp.description || "",
    });

    protectLoadedStore(store);
    return true;
  } catch (e) {
    console.error(`[prefill] Failed for ${comp.type}/${comp.componentId}:`, e);
    return false;
  }
}

export function hydrateComponentStoreFromCanvas(
  componentId,
  componentType,
  version,
) {
  const components = useProjectStore.getState().components || [];
  const component =
    components.find(
      (comp) => comp.componentId === componentId && comp.type === componentType,
    ) || components.find((comp) => comp.componentId === componentId);

  return hydrateComponentStoreFromComponent(component, version, componentType);
}

/**
 * Prefills all keyed component stores from the rawComponentData returned
 * by the GraphQL canvas query. This eliminates the REST fetch on pane open.
 *
 * @param {Array} components - components array from the GraphQL response
 * @param {number} version - current workflow version
 */
export function prefillComponentStores(components, version) {
  if (!components) return;

  for (const comp of components) {
    hydrateComponentStoreFromComponent(comp, version);
  }
}
